import './style.css';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import TWEEN from '@tweenjs/tween.js';
import info from './info.json';
import env from '../static/option/env.json';

// Canvas
const canvas = document.querySelector('canvas.webgl');

let model;
let spriteBehindObject;
let annotationPos = [];
let annotations = [];
let sprites = [];
let cameraPositions = [];
let cameraAnimation;
let zIndex = 100;

// Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color(0xededed);

const ambientLight = new THREE.AmbientLight(0xffffff, env.ambientLight);

const directLight = new THREE.DirectionalLight(0xffffff, env.directionalLight);
directLight.position.set(0.5, 0, 0.866); // ~60º

// Sizes
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

// Camera
const camera = new THREE.PerspectiveCamera(
  50,
  sizes.width / sizes.height,
  0.001,
  1000
);

camera.add(ambientLight);
camera.add(directLight);

scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.enableZoom = true;
controls.enablePan = false;
controls.minDistance = 0.01;
// controls.maxDistance = 0.1;

//Renderer
const renderer = new THREE.WebGLRenderer({
  canvas,
  antialias: true,
});
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(sizes.width, sizes.height);
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.shadowMap.enabled = true;
renderer.receiveShadow = true;

let drag = false,
  pointerDown = false;
renderer.domElement.addEventListener('pointerdown', onPointerDown);
renderer.domElement.addEventListener('pointerup', onPointerUp);
renderer.domElement.addEventListener('pointermove', onPointerMove);
renderer.domElement.addEventListener('touchmove', onPointerMove);

// Animate
function tick() {
  // Update Orbital Controls
  controls.update();

  TWEEN.update();

  // Render
  renderer.render(scene, camera);

  model && updateAnnotationOpacity();
  model && updateScreenPosition();

  // console.log(camera.position);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
}

tick();

// 특정 경로 모델을 불러온다.
function onGltfLoader(filePath) {
  // 이 전 모델 데이터 있을 경우 화면 상에서 삭제
  if (model !== undefined) {
    scene.remove(model);
    // 값 초기화
    model = '';
    spriteBehindObject = '';
    annotationPos = [];
    annotations = [];
    sprites = [];
    cameraPositions = [];
    document.querySelector('#annotations').innerHTML = '';
  }
  // Gltf Loader
  const gltfLoader = new GLTFLoader();
  gltfLoader.load(
    `./model/ZENEX ${filePath.kitName}/${filePath.folderName}/${filePath.fileName}.glb`,
    (gltf) => {
      var index = 1;
      gltf.scene.traverse((obj) => {
        if (obj.isMesh) {
          obj.castShadow = true;
        }
        if (
          filePath.fileName == 'Guide Kit' ||
          filePath.fileName == 'Surgery Kit' ||
          filePath.fileName == 'Easy Surgery Kit' ||
          filePath.fileName == 'Simple Kit' ||
          filePath.fileName == 'ZMSR4510' ||
          filePath.fileName == 'ZPSR4510'
        ) {
          if (obj.name.indexOf('Empty_') > -1) {
            annotationPos.push(obj.position);
            addAnnotation(index++);
            addCircleMark(obj.position, index);
          }
        }
      });

      // 모델 불러 온 후 카메라 초기화
      for (const key in info) {
        if (Object.hasOwnProperty.call(info, key)) {
          if (info[key].key == filePath.fileName) {
            const data = info[key].info;
            camera.position.x = data.initPosition.x;
            camera.position.y = data.initPosition.y;
            camera.position.z = data.initPosition.z;
            addTextBox(data);
            break;
          }
        }
      }

      model = gltf.scene;
      scene.add(model);
      tick();
      document.querySelector('.divLog').innerText = '';
      sendMsgToParent({
        loadingComplete: true,
      });
    },
    undefined,
    (error) => {
      console.error(error);
      document.querySelector('.divLog').innerText = error;
      sendMsgToParent({
        loadingComplete: true,
      });
    }
  );
}

// 포인트 및 텍스트 박스 태그 추가
function addAnnotation(index) {
  const annotation = document.createElement('div');
  annotation.className = `annotation annotation${index}`;
  annotation.innerHTML = `<div class="box box${index}">
    <div class="circleMark circleMark${index}"></div>
    <div id="textBox_${index}" class="boxInner">
      <button type="button" class="boxClose">닫기</button>
    </div>
  </div>`;
  document.querySelector('#annotations').append(annotation);
  annotations.push(annotation);
}

// 포인트 스프라이트 추가
function addCircleMark(position, index) {
  const spriteMaterial = new THREE.SpriteMaterial({
    alphaTest: 0.5,
    transparent: true,
    depthTest: false,
    depthWrite: false,
  });

  const sprite = new THREE.Sprite(spriteMaterial);
  sprite.position.set(position.x, position.y, position.z);
  sprite.scale.set(0.001, 0.001, 0.001);
  sprite.name = `sprite_${index - 1}`;
  sprite.material.opacity = 0;

  sprites.push(sprite);
  scene.add(sprite);
}

// 텍스트 박스 추가
function addTextBox(data) {
  if (data.points) {
    data.points.forEach((point, index) => {
      cameraPositions.push(point.position);

      const textBox = document.querySelector(`#textBox_${index + 1}`);
      if (textBox) {
        textBox.innerHTML += `
        <div class="textWrap">
          <p class="title"><strong>${point.title}</strong></p>
          <ul class="list">
            ${addTextList(point.text)}
          </ul>
        </div>
      `;
        if (point.image) {
          textBox.innerHTML += `<div class='imgWrap'><img src=${point.image.src}></div>`;
        }
      }
    });
  }
}

// 텍스트 설명 추가
function addTextList(list) {
  return list.map((text) => `<li>${text}</li>`).join('');
}

// 포인트 모델 뒤로 이동 할 경우 투명도 조절
function updateAnnotationOpacity() {
  sprites.forEach((sprite) => {
    const modelDistance = camera.position.distanceTo(model.position);
    const spriteDistance = camera.position.distanceTo(sprite.position);
    spriteBehindObject = spriteDistance > modelDistance;
    document.querySelector(
      `.annotation${sprite.name.split('_')[1]}`
    ).style.opacity = spriteBehindObject ? 0.25 : 1;
  });
}

// 포인트 모델링 상 좌표로 계속 이동
function updateScreenPosition() {
  annotations.forEach((annotation, index) => {
    const position = annotationPos[index];
    const vector = new THREE.Vector3(position.x, position.y, position.z);
    const canvas = renderer.domElement;
    vector.project(camera);
    vector.x = Math.round(
      (0.5 + vector.x / 2) * (canvas.width / window.devicePixelRatio)
    );
    vector.y = Math.round(
      (0.5 - vector.y / 2) * (canvas.height / window.devicePixelRatio)
    );
    annotation.style.top = `${vector.y - 50}px`;
    annotation.style.left = `${vector.x - 50}px`;
  });
}

// 카메라 이동 애니메이션
function moveCameraToPosition(position) {
  cameraAnimation = new TWEEN.Tween(camera.position)
    .to({ x: position.x, y: position.y, z: position.z }, 1000)
    .easing(TWEEN.Easing.Quadratic.Out)
    .onUpdate(() => {
      controls.update();
    })
    .start();
}

// 텍스트 박스 보여줌
function showTextBox(index) {
  document.querySelectorAll('.boxInner').forEach((box) => {
    if (box.id.split('_')[1] == index) {
      box.style.visibility = 'visible';
    } else {
      box.style.visibility = 'hidden';
    }
  });
}

// 모든 클릭 원 이전 상태로 되돌림
function clearCircle() {
  document.querySelectorAll('.circleMark').forEach((circle) => {
    circle.classList.remove('is-active');
  });
}

window.addEventListener('message', receiveMsgFromParent);
// 부모로부터 메시지 수신
async function receiveMsgFromParent(e) {
  if (e.data && e.data.type && e.data.type == 'render') {
    // hdr Loader
    const rgbeLoader = new RGBELoader();
    rgbeLoader.load(
      './hdr/studio.hdr',
      async (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        //scene.background = texture;
        scene.environment = texture;
        await onGltfLoader(e.data);
        directLight.intensity = env.directionalLight;
      },
      undefined,
      (error) => {
        console.error(error);
        document.querySelector('.divLog').innerText = error;
      }
    );
  }
}

// 부모에게 메시지 전달
function sendMsgToParent(msg) {
  window.parent.postMessage(msg, '*');
}

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

document.addEventListener('click', (e) => {
  if (e.target.className.indexOf('circleMark') > -1) {
    clearCircle();
    e.target.classList.add('is-active');
    const targetIndex = e.target.className.replace(/[^0-9]/g, '');
    document.querySelector(`.annotation${targetIndex}`).style.zIndex = zIndex++;
    const cameraPosition = new THREE.Vector3(
      cameraPositions[targetIndex - 1].x,
      cameraPositions[targetIndex - 1].y,
      cameraPositions[targetIndex - 1].z
    );
    moveCameraToPosition(cameraPosition);
    showTextBox(targetIndex);
  } else if (e.target.className == 'boxClose') {
    showTextBox(-1);
    clearCircle();
  }
});

function onPointerDown() {
  pointerDown = true;
}

function onPointerUp() {
  pointerDown = false;
}

function onPointerMove(event) {
  drag = event.pressure;
  if (drag == 0.5 || pointerDown) {
    cameraAnimation && cameraAnimation.stop();
    showTextBox(-1);
    clearCircle();
  }
}
